import { NetworkActionPrefix } from '../utils/constants';
import { LivingStrategyDashboardReportApi } from 'for-straction-service-api'
import { networkAPIAction } from '../utils/actionCreatorsFactory';

export const loadLivingStrategyDashboardReport = () =>
    networkAPIAction(LivingStrategyDashboardReportApi, 'livingStrategyDashboardReportLoadGet', NetworkActionPrefix.LOAD_LIVING_STRATEGY_DASHBOARD_REPORT_PREFIX);